///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2023 - 2023
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import messages from "../../../helpers/messages";
import mapRankByVolumeGraphDetails from "../../../helpers/mapRankByVolumeGraphDetails";
import { division as divisionType } from "../../../helpers/types";
import InfoIcon from "../../icons/InfoIcon";
import Tooltip from "../../Tooltip";

export const RankBreakdown = ({ currency, division }) => {
  const {
    analytics: { loads }
  } = useSelector(state => state);

  const [rankBreakdown, setRankBreakdown] = useState(null);

  useEffect(() => {
    const includedLoads = loads?.filter(l => !l.exclude);
    setRankBreakdown(mapRankByVolumeGraphDetails(includedLoads));
  }, [loads]);

  return (
    <div className="one-whole mb-8">
      <div className="label heading text-center">
        {messages.rankBreakdown.defaultMessage}
        <Tooltip
          content={messages.rankInfoTooltip.defaultMessage}
          placement="top-end"
          offset={[10, 8]}
          className="tooltip info"
        >
          <span className="align-middle ml-4">
            <InfoIcon width="12" height="12" title="" fill="#0088D1" />
          </span>
        </Tooltip>
      </div>
      {rankBreakdown?.map(rank => {
        return (
          <div key={rank.name}>
            <div
              className="label text-center pt-8 pb-8"
              data-testid="rank-name"
            >
              {rank.name}
            </div>
            <div className="grid section-grid">
              <div
                className="grid__cell one-half tiny-label key"
                data-testid="avg-cost"
              >
                {messages.avgCost.defaultMessage}
              </div>
              <div
                className="grid__cell one-half tiny-label value text-right"
                data-testid="avg-cost-value"
              >
                {currency}
                {rank.averageCost}
              </div>
              <div
                className="grid__cell one-half tiny-label key"
                data-testid="avg-cpm"
              >
                {division === divisionType.coy
                  ? messages.avgCpm.defaultMessage
                  : messages.avgCpKm.defaultMessage}
              </div>
              <div
                className="grid__cell one-half tiny-label value text-right"
                data-testid="avg-cpm-value"
              >
                {currency}
                {rank.averageCpm}
              </div>
              <div
                className="grid__cell one-half tiny-label key"
                data-testid="vol"
              >
                {messages.volume.defaultMessage}
              </div>
              <div
                className="grid__cell one-half tiny-label value text-right"
                data-testid="vol-value"
              >
                {rank.volume}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default RankBreakdown;
